// extracted by mini-css-extract-plugin
export default {"content":"Mpa-z","title":"Npa-z","subTitle":"Opa-z","banner":"Ppa-z","productCardOverride":"Qpa-z"};